import { pathJoin } from 'src/reducers/routing/utils'

import { createEditRouteMap } from './edit'

export const createOffersRoutesMap = (prefix: string) => ({
  'edit/:id': (id: string) =>
    pathJoin(prefix)(`edit`)(id).chainMapAuto(createEditRouteMap),
})
